import { type Route } from './+types/registration-confirmation.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'EBHS Events - 2025 Car Show and Parade' },
]

export default function RegistrationConfirmation() {
	return (
		<>
			<header className="py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<h2 className="text-3xl font-bold leading-tight text-gray-900">
						Registration Confirmation
					</h2>
				</div>
			</header>
			<div className="px-4 pt-4 pb-8">
				<div className="prose mx-auto max-w-6xl text-lg sm:px-6 lg:px-8">
					<p>
						Thank you for registering for the 2025 Car Show and Parade!
					</p>

					<p>
						Registrants can pay the $15 pre-registration fee (Due by July
						19) through paypal here:
						<form
							action="https://www.paypal.com/donate"
							method="post"
							target="_blank"
							className="not-prose my-6"
						>
							<input
								type="hidden"
								name="hosted_button_id"
								value="77YWK8A2WPZ8N"
							/>
							<button
								type="submit"
								className="hover:bg-ebhs-blue-light inline-flex items-center rounded-full border border-transparent bg-ebhs-blue px-6 py-3 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
							>
								Make a $15 Donation for 2025 Car Show Registration
							</button>
						</form>{' '}
						Or mail a check payable to East Bloomfield Historical Society to
						PO Box 212, East Bloomfield, NY 14443
					</p>
				</div>
			</div>
		</>
	)
}
